function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgAnimaisEAcessorios = function SvgAnimaisEAcessorios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95 1.992a2.75 2.75 0 00-3.185 2.23c-.339 1.923.35 4.378 1.97 4.664 1.63.287 3.105-1.776 3.446-3.708a2.75 2.75 0 00-2.23-3.186zm4.908 10.55c-1.029-2.194-3.923-2.704-5.64-.993L5.8 14.957c-2.007 2-.928 5.433 1.863 5.925l.421.074.929.164 1.15.202 1.364.241 1.603.284c2.792.491 4.98-2.367 3.777-4.934l-2.05-4.37zm-6.6 7.43l-.42-.075c-1.995-.351-2.765-2.803-1.332-4.232l3.418-3.408a2.5 2.5 0 014.028.71l2.05 4.37c.86 1.835-.704 3.876-2.698 3.525l-1.603-.284-1.365-.24-1.15-.203h-.002l-.926-.164zM7.749 4.395c-.254 1.446.28 3.35 1.16 3.505.887.157 2.03-1.442 2.287-2.897a1.75 1.75 0 00-3.447-.608zm11.824 2.085a2.75 2.75 0 10-5.416-.955c-.338 1.923.35 4.377 1.97 4.663 1.63.288 3.106-1.776 3.446-3.708zm-3.272 2.723c.888.157 2.03-1.442 2.288-2.896a1.75 1.75 0 10-3.447-.608c-.255 1.445.279 3.35 1.159 3.504zM3.744 6.99A2.75 2.75 0 00.559 9.22c-.307 1.739.472 3.639 2.1 3.925 1.637.29 3.008-1.223 3.316-2.969A2.75 2.75 0 003.744 6.99zm-2.2 2.404c-.223 1.263.323 2.596 1.29 2.766.972.172 1.932-.888 2.156-2.158a1.75 1.75 0 00-3.446-.608zm19.927.722a2.75 2.75 0 00-3.186 2.231c-.306 1.738.473 3.637 2.101 3.924 1.637.289 3.009-1.225 3.315-2.97a2.75 2.75 0 00-2.23-3.185zm-2.2 2.405c-.223 1.262.323 2.595 1.289 2.765.972.172 1.933-.889 2.157-2.158a1.75 1.75 0 10-3.447-.607z",
    fill: props.color
  }));
};
SvgAnimaisEAcessorios.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgAnimaisEAcessorios.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgAnimaisEAcessorios;